import { Event, Post } from '@tribeplatform/gql-client/types'

import {
  ExtendedSmartSearchEntity,
  ExtendedSmartSearchEntityType,
} from '../../../SmartSearch.types.js'

import { SearchEntityRowTrailingContent } from './SearchEntityRowTrailingContent.js'

interface Props {
  item: ExtendedSmartSearchEntity
  entityType: ExtendedSmartSearchEntityType
}

export const SearchEntityRowTrailing = ({ item, entityType }: Props) => {
  const isEvent = entityType === ExtendedSmartSearchEntityType.EVENTS

  if (isEvent) {
    const event = item as Event
    return (
      <SearchEntityRowTrailingContent
        space={event.space}
        date={event.createdAt}
      />
    )
  }

  const isPost =
    entityType === ExtendedSmartSearchEntityType.POSTS ||
    entityType === ExtendedSmartSearchEntityType.OFFICIAL_POSTS

  if (!isPost) {
    return null
  }

  const post = item as Post
  return (
    <SearchEntityRowTrailingContent
      space={post.space}
      date={post.publishedAt}
    />
  )
}
